import { render, staticRenderFns } from "./BasePopupVideoPreview.vue?vue&type=template&id=053621c4&scoped=true"
import script from "./BasePopupVideoPreview.vue?vue&type=script&lang=js"
export * from "./BasePopupVideoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053621c4",
  null
  
)

export default component.exports